import React from 'react';
import PropTypes from 'prop-types';
import { generatePlayScoresInfo } from '../../Play/play/PlayScores';
import { ScoreWrapper } from './Summary.style';

const Score = ({
    awayScore,
    homeScore,
    away,
    home,
    isMobile,
    isTopInning,
    isScoringPlay
}) => {

    const {
        InfoComp
    } = generatePlayScoresInfo({
        isFinal: false, 
        homeScore, 
        awayScore, 
        homeTeam: home?.team, 
        awayTeam: away?.team,
        isTopInning,
        isScoringPlay
    });

    return (
        <ScoreWrapper isMobile={isMobile} >{InfoComp}</ScoreWrapper>
    );
};

Score.propTypes = {
    awayScore: PropTypes.number,
    homeScore: PropTypes.number,
    away: PropTypes.object,
    home: PropTypes.object,
    isMobile: PropTypes.bool
};

export default Score;